app.directive('scrollTo', ["$timeout", function($timeout) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			element.on('click', function() {
				// Odotetaan yksi sykli, koska joissain tapauksissa pitää odottaa, että elementti tulee näkyviin ennen kuin scrollataan.
				$timeout(function() {
					// scrollExtraSpace jotta saadaan haluttu määrä "ilmaa" scrollTo-elementin yläpuolelle
					if(attrs.scrollTo[0] != "." && attrs.scrollTo[0] != "#") {
						$("body,html").animate({scrollTop: $("#"+attrs.scrollTo).offset().top - (attrs.scrollExtraSpace || 0)}, "slow");
					}
					else {
						$("body,html").animate({scrollTop: $(attrs.scrollTo).offset().top - (attrs.scrollExtraSpace || 0)}, "slow");
					}

				});
			});
		}
	};
}]);